module.exports = __webpack_public_path__ + "img/video607.0f616393.jpg";